<template>
    <Teleport to="body">
        <div v-if="show"
             class="absolute z-[10050] border border-n-slate-3 rounded-md shadow-lg bg-white dark:bg-slate-800 max-h-80 overflow-hidden flex flex-col"
             :style="dropdownStyles"
             @click.stop>
            <slot></slot>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: 'TeleportedDropdown',
    props: {
        show: {
            type: Boolean,
            required: true
        },
        triggerRef: {
            type: Object,
            default: null
        },
        maxHeight: {
            type: Number,
            default: 320 // 20rem = 320px
        }
    },
    emits: ['click'],
    computed: {
        dropdownStyles() {
            if (!this.triggerRef || !this.show) return {};

            const rect = this.triggerRef.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Check if dropdown would extend beyond viewport
            const spaceBelow = viewportHeight - rect.bottom;
            const shouldShowAbove = spaceBelow < this.maxHeight && rect.top > this.maxHeight;

            if (shouldShowAbove) {
                return {
                    left: `${rect.left}px`,
                    bottom: `${viewportHeight - rect.top + 2}px`,
                    width: `${rect.width}px`
                };
            } else {
                return {
                    left: `${rect.left}px`,
                    top: `${rect.bottom + 2}px`,
                    width: `${rect.width}px`
                };
            }
        }
    }
}
</script>
